import { NW_JS_APP_PROFILES } from 'enums'
import { translations } from 'translations/translations'
import { EDITOR_MAIN_SETTINGS } from 'config/constants/mainView'

const getStoredLang = () => {
  try {
    const view = JSON.parse(localStorage.getItem(EDITOR_MAIN_SETTINGS.VIEW) || '{}')
    return view?.lang in translations ? view.lang : null
  } catch {
    return null
  }
}

export const getLang = () => {
  const storedLang = getStoredLang()
  if (storedLang) {
    return storedLang
  }
  // special case for pt-BR
  let navLang = navigator.language || navigator.userLanguage
  if (navLang === 'pt-BR') {
    navLang = 'bz'
  }
  let lang = (navLang).substr(0, 2)
  if (NW_JS_APP_PROFILES.includes(__APP_PROFILE__)) {
    lang = (global.process?.env?.LANG || 'en-US').substr(0, 2)
  }
  return lang
}
